//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppCardCode from '@/@core/components/app-card-code/AppCardCode.vue'

// demos
import DemoFormLayoutHorizontal from './demos/DemoFormLayoutHorizontal.vue'
import DemoFormLayoutHorizontalIcon from './demos/DemoFormLayoutHorizontalIcon.vue'
import DemoFormLayoutVerticalForm from './demos/DemoFormLayoutVerticalForm.vue'
import DemoFormLayoutVerticalFormWithIcons from './demos/DemoFormLayoutVerticalFormWithIcons.vue'
import DemoFormLayoutMultipleColumn from './demos/DemoFormLayoutMultipleColumn.vue'
import DemoFormLayoutHint from './demos/DemoFormLayoutHint.vue'
import DemoFormLayoutValidation from './demos/DemoFormLayoutValidation.vue'
import DemoFormLayoutTabs from './demos/DemoFormLayoutTabs.vue'
import DemoFormLayoutCollapsible from './demos/DemoFormLayoutCollapsible.vue'

// code
import {
  formLayoutHorizontal,
  formLayoutHorizontalIcon,
  formLayoutVerticalForm,
  formLayoutVerticalFormWithIcons,
  formLayoutMultipleColumn,
  formLayoutHint,
  formLayoutValidation,
  formLayoutTabs,
} from './demos/code'

export default {
  components: {
    AppCardCode,
    DemoFormLayoutHorizontal,
    DemoFormLayoutHorizontalIcon,
    DemoFormLayoutVerticalForm,
    DemoFormLayoutVerticalFormWithIcons,
    DemoFormLayoutMultipleColumn,
    DemoFormLayoutHint,
    DemoFormLayoutValidation,
    DemoFormLayoutTabs,
    DemoFormLayoutCollapsible,
  },
  setup() {
    return {
      codeSnippets: {
        formLayoutHorizontal,
        formLayoutHorizontalIcon,
        formLayoutVerticalForm,
        formLayoutVerticalFormWithIcons,
        formLayoutMultipleColumn,
        formLayoutHint,
        formLayoutValidation,
        formLayoutTabs,
      },
    }
  },
}
